import React, {Component} from 'react';
import './App.css';
import Cards from './components/Cards';
import Header from './components/Header';


function App() {
  return (
<div>
      <Header />
      <Cards />
       
</div>
      );
}
export default App;
